import { isHtmlUrl } from "../../configs/templateTypes";

export function resolveIssuedArtwork(row = {}) {
  const htmlUrl = row.html_url || "";
  const url = htmlUrl || row.svg_url || "";
  return {
    url,
    artifactType: htmlUrl || isHtmlUrl(url) ? "html" : "svg",
    thumbnailUrl: row.thumbnail_url || "",
  };
}
